import { Outlet } from 'react-router-dom';

import { SiteHeader } from './components/SiteHeader';

/**
 * Chrome for the catalog and master showcase pages.
 *
 * Uses the solid header and drops the footer: these pages own their own
 * scrolling regions and end in a booking call to action, not a sitemap.
 */
export const CatalogLayout = () => (
  <>
    <SiteHeader variant="catalog" />
    <main className="flex-1 text-left">
      <Outlet />
    </main>
  </>
);
